import { memo, useCallback, useRef, useState, useLayoutEffect, useMemo } from 'react';
import Image from '@picsart/image/Image';
import View from '@picsart/view/View';

import useStyles from 'components/common/GridItemImageBox/useStyles';
import getGridImageSizes from 'utils/images/getGridImageSizes';
import { IWatermarkGridItem } from 'pages/Batch/types';

const WatermarkGridItem = ({
  imgSrc, // TODO imgSRC need's to be changed to src
  boxWidth,
  boxHeight,
}: IWatermarkGridItem) => {
  const canvasRef = useRef<HTMLDivElement>(null);
  const imageRef = useRef<HTMLImageElement>(null);
  const [preventImgRendering, setPreventImgRendering] = useState(false);
  const [{ width, height }, setImageBoxSize] = useState({
    width: '0',
    height: '0',
  });

  const isRenderableImg = useMemo(() => typeof imgSrc === 'string', [imgSrc]);

  const classes = useStyles({
    width,
    height,
  });

  useLayoutEffect(() => {
    if (canvasRef.current && imgSrc instanceof HTMLCanvasElement) {
      // eslint-disable-next-line no-param-reassign
      imgSrc.style.width = '100%';

      // Clear the existing content
      canvasRef.current.innerHTML = '';
      // Append the canvas element to the ref's current element
      canvasRef.current.appendChild(imgSrc);
    }
  }, [imgSrc]);

  const handleImageSize = useCallback((wrapperWidth: number, wrapperHeight: number) => {
    const imgBoxSizes = getGridImageSizes(wrapperWidth, wrapperHeight, imageRef.current as HTMLImageElement);
    setImageBoxSize(imgBoxSizes);
  }, []);

  const onImageLoad = useCallback(() => {
    setPreventImgRendering(true);
    handleImageSize(boxWidth, boxHeight);
  }, [boxWidth, boxHeight, handleImageSize]);

  const showImg = (isRenderableImg && (!canvasRef.current || !preventImgRendering));

  return (
    <div className={classes.gridImageWrap}>
      {showImg ? (
        <Image
          ref={imageRef}
          className={classes.gridImage}
          src={imgSrc as string}
          onLoad={onImageLoad}
          alt="img"
        />
      ) : (
        <View ref={canvasRef} />
      )}
    </div>
  );
};

export default memo(WatermarkGridItem);
